<template>
	<el-dialog :visible.sync="is_visible" :width="'35%'" @close="close"  title="Case Status Form">
		<b-form @submit.prevent="submit" ref="statusForm">
      <b-row>
        <!-- FIELD STATUS -->
        <b-col cols="12">
          <b-form-group label="Status:">
            <b-form-input v-model="form.name" type="text" required :readonly="readOnlyItems.includes(form.name)"></b-form-input>
          </b-form-group>
        </b-col>

				<b-col cols="12">
          <b-form-group label="Color Label">
            <el-select v-model="form.color_class" placeholder="Select">
              <el-option v-for="(item,index) in _gConst.colorClassList" :key="index" :label="item.label" :value="item.color_class" :class="item.color_class">
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Tat Days:">
            <b-form-input v-model="form.tat_day" type="text" required></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox v-model="form.stop_tat">Stop TAT Tracking</b-form-checkbox>
        </b-col>

        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
          <b-button variant="primary" type="submit" class="w-100" v-if="is_new_record">Create</b-button>
          <b-button variant="primary" type="submit" class="w-100" v-if="!is_new_record">Update</b-button>
        </b-col>
      </b-row>
    </b-form>
	</el-dialog>
</template>
<script>

import { Select, Option, Checkbox, Dialog } from 'element-ui'
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';

export default {
	props: [
    'module',
		'readOnlyItems'
  ],
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
			is_visible: false,
			is_loading: false,
			mainStatus: [],
      form: {
        id: '',
        name: '',
        color_class: '',
        group_name: '',
        parent_id: '',
        tat_day: 0,
        stop_tat: 0
      },
      statusOptions: [{
        value: 'Main',
        label: 'Main'
      }, {
        value: 'Sub',
        label: 'Sub'
      }]
    }
  },
  computed: {
		is_new_record(){
			return _gHlp.isEmpty(this.form.id)
		}
  },
  created() {
  },
  watch: {
    "form.group_name"(newVal) {
      if (newVal == "main") {
        this.form.parent_id = null;
      }
    }
  },
  methods: {
    ...mapActions(useCommonStore, ['createStatus', 'updateStatus']),
		show(item, parentList=[]) {
			if (!_gHlp.isEmpty(item)) {
				this.form = item
			}
			this.mainStatus = parentList
			this.is_visible = true
		},
		close() {
			this.is_visible = false
			this.is_loading = false
			this.form = {
				id: '',
        name: '',
        group_name: '',
        parent_id: '',
        tat_day: 0,
        stop_tat: 0
			}
		},
		submit() {
			//CREATE
			this.is_loading = true;
			const formData = {
        module: this.module,
        ...this.form
      };
			if (!_gHlp.isEmpty(this.form.id)) {
				this.updateStatus(this.form.id, formData).then((resp) => {
          _gNotif.notifySuccess('<b>Status</b> - Successfully Updated.')
				  this.$emit('closeModal',true);
					this.close();
        }).catch(err => {
					_gNotif.notifySuccess('<b>Status</b> - Failed to Update.')
					this.is_loading = false;
				})
			} else {
				this.createStatus(formData).then(resp => {
					_gNotif.notifySuccess('<b>Status</b> - Successfully Created.')
					this.$emit('closeModal', true)
					this.close();
				}).catch(err => {
					_gNotif.notifySuccess('<b>Status</b> - Failed to Create.')
					this.is_loading = false;
				})
			}
		}
  }
}
</script>